import React from 'react';
import * as XLSX from 'xlsx';
import {Button, message} from 'antd';

export const ExportToExcel = ({tableData}) => {
	return (
		<Button style={{marginBottom: 10, marginLeft: 10, float: 'right'}} onClick={() => handleExport(tableData)}
				type="primary">
			导出到Excel
		</Button>
	);
};

// 获取 20230630111310 形式的时间字符串作为导出的 Excel 文件名
const generateFileName = () => {
	const date = new Date();
	return `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().
		toString().
		padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().
		toString().
		padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
};

export const handleExport = (tableData) => {
	if (tableData && tableData.length > 0) {
		const filteredData = tableData.map(({_changed, _id, recordModifyEnable, voConfigType, state, ...rest}) => rest);
		const maxRowsPerSheet = 10000; // 每个工作表最大行数
		const workbook = XLSX.utils.book_new();
		// 将列表中的内容去重，不对全部社团个人会员去重，因为后端已经去重了，避免不一致
		let uniqueList = filteredData;
		if (filteredData.length < 3000) {
			uniqueList = getUniqueList(filteredData);
		}
		const totalRows = uniqueList.length;
		const totalSheets = Math.ceil(totalRows / maxRowsPerSheet); // 计算所需的工作表数量
		try {
			for (let sheetIndex = 0; sheetIndex < totalSheets; sheetIndex++) {
				const startRow = sheetIndex * maxRowsPerSheet;
				const endRow = Math.min(startRow + maxRowsPerSheet, totalRows);
				const sheetData = uniqueList.slice(startRow, endRow);
				const worksheet = XLSX.utils.json_to_sheet(sheetData);
				XLSX.utils.book_append_sheet(workbook, worksheet, `Sheet${sheetIndex + 1}`);
			}
			XLSX.writeFile(workbook, `${generateFileName()}.xlsx`);
		} catch (error) {
			message.error(error.toString() || '单元格内数据错误，请检查后再试.');
		}
	} else {
		message.error('内容为空无法导出.');
	}
};

export const getUniqueList = (excelData) => {
	return excelData.filter((arr, index) => {
		const stringifiedArr = JSON.stringify(arr);
		return (
			index ===
			excelData.findIndex((item) => {
				return JSON.stringify(item) === stringifiedArr;
			})
		);
	});
};